<template>
	<div class="wrap">
		<Xinde ref="xinde"></Xinde>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="dydetail1">
						<div class="dyimg">
							<img src="../../../assets/images/moren.png" 
							v-if="bindatas.sz_img==''||bindatas.sz_img==null||bindatas.sz_img.search('http')==-1">
							<img :src="bindatas.sz_img" v-else>
						</div>
						<el-descriptions class="margin-top" 
							:title="bindatas.title"  
							size="medium"
							:column="1" >
							<template slot="extra">
								<el-button type="primary" size="small">导出</el-button>
								<el-button type="primary" size="small" @click="$router.go(-1)">返回上级</el-button>
							</template>
							<el-descriptions-item>发布组织 : {{bindatas.dw}}</el-descriptions-item>
							<el-descriptions-item>活动类型 : {{bindatas.t_name}}</el-descriptions-item>
							<el-descriptions-item>活动时间 : {{$changeTime(bindatas.h_stime)}}</el-descriptions-item>
							<el-descriptions-item>活动地点 : {{bindatas.h_address}}</el-descriptions-item>
							<el-descriptions-item v-if="bindatas.hours">培训时长 : {{bindatas.hour}}时</el-descriptions-item>
							<el-descriptions-item v-if="tags.length>0">
								<el-tag
									:key="index"
									style="margin-right: 10px;"
									v-for="(tag,index) in tags"
									:closable="false"
									:disable-transitions="false"
									type="info">
									{{tag}}
								</el-tag>
							</el-descriptions-item>
						</el-descriptions>
					</div>
					<div class="step_box">
						<!-- 参与党组织 -->
						<div class="cyzz">
							<div class="zztitle">参与组织：</div>
							<div class="zzlist">{{bindatas.u_name}}</div>
						</div>
						<div class="cyzz">
							<div class="zztitle">应到人员 ({{attend}})：</div>
							<div class="zzlist">
								<span :key="index" v-for="(item,index) in bindatas.dy_name" @click="openXinde">{{item}}、</span>
							</div>
						</div>
						<div class="cyzz">
							<div class="zztitle">实到人员 {{attended}} ：</div>
							<div class="zzlist">
								<span :key="index" v-for="(item,index) in bindatas.sign_name">{{item}}、</span>
							</div>
						</div>
						<div class="cyzz" v-if="bindatas.status==2">
							<div class="zztitle">活动记录：</div>
							<div class="zzlist">
								<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="bindatas.record" style="height:327px !important;width: 800px;"></quill-editor>
								<div style="margin-top: 80px;"><el-button type="primary" @click="submitHyjl">保存</el-button></div>
							</div>
						</div>
						<div class="cyzz" v-if="fileList.length>0">
							<div class="zztitle">活动附件：</div>
							<div class="zzlist">
								<div class="flieItem" v-for="item in fileList">
									<img src="../../../assets/images/show_f.png">
									<span class="fileTitle">{{item.title}}</span>
									<span @click="download(item.src)"><i class="el-icon-download"></i></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import shykDetaill from './mixins/shyk_detaill.js'
	export default {
		mixins:[shykDetaill]
	}
</script>

<style lang="scss">
	.el-descriptions__title{
		display: flex;
		font-size: 20px;
		align-items: center;
	}
	.el-descriptions-item__label.has-colon::after{
		content: "" !important;
	}
	.dydetail1{
		width: 100%;
		display: flex;
		.dyimg{
			width: 346px !important;
			height: 211px;
			background: #DDDDDD;
			margin-right: 15px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	.el-descriptions{
		flex: 1;
	}
	.subtitle{
		width: 100%;
		height: 50px;
		border: 1px solid #DDDDDD;
		line-height: 50px;
		border-left: none;
		margin: 20px 0;
		color: #333;
		font-size: 14px;
		border-right: none;
		>span{
			display: inline-block;
			height: 100%;
			cursor: pointer;
			border-bottom: 2px solid rgba($color: #000000, $alpha: 0);
			padding: 0 20px;
		}
		>span:hover{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
		.selectBar{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
	}
	.step_box{
		margin: 23px 0;
		padding: 5px 0;
		width: 100%;
		border-top: 1px solid #DDE2EE;
		border-bottom: 1px solid #DDE2EE;
	}
	.el-step__title.is-process{
		color: #1266E3 !important;
	}
	.el-step__head.is-process{
		color: #1266E3 !important;
		border-color: #1266E3 !important;
	}
	.el-step__title.is-process{
		color: #1266E3 !important;
	}
	.cyzz{
		margin: 20px 0;
		width: 100%;
		font-size: 16px;
		.zztitle{
			font-weight: bold;
			padding-right: 10px;
			font-size: 15px;
			line-height: 26px;
			color: #3C4353;
		}
		.zzlist{
			margin: 10px 0;
			max-height: 600px;
			font-weight: 400;
			overflow-y: scroll;
			.flieItem{
				margin-bottom: 20px;
				width: 500px;
				border: 1px solid #DDDDDD;
				padding: 20px;
				box-sizing: border-box;
				align-items: center;
				img{
					width: 30px;
					height: 30px;
					margin-right: 20px;
				}
				.fileTitle{
					color: #bb0000;
					display: inline-block;
					width: 380px;
					font-size: 14px;
				}
			}
		}
		.zzlist1{
			margin-top: 20px;
			width: 80%;
			padding: 30px 30px;
			background: #FAFBFC;
			line-height: 30px;
			font-size: 14px;
			border: 1px solid #DDE2EE;
			img{
				width: 80%;
				margin: 10px 0;
			}
		}
	}
</style>

